import { React, useState } from 'react'
import QUES_ANS_LIST from './QAList'
import QACard from './elements/QACard'
import styles from './styles'
import GetStartedModal from 'components/GetStartedModal'
import BigModal from 'components/BigModal'

const FAQ = () => {
  const [isModalOpen, setModalOpen] = useState(false)

  return (
    <div className={styles.faqWrapper}>
      <h2 className={styles.heading}>FAQs</h2>
      <div className={styles.qaCards}>
        {QUES_ANS_LIST.map((qa, i) => (
          <QACard key={`${i}-${qa}`} question={qa.question} answer={qa.answer} sourceDetail={qa.sourceDetail} />
        ))}
      </div>
      <div className={styles.footerContainer}>
        Have more questions?
        <a onClick={() => setModalOpen(true)} className={styles.footerButton} type="button">
          Get in touch
        </a>
      </div>
      <BigModal open={isModalOpen} handleClose={() => setModalOpen(false)}>
        {({ close }) => <GetStartedModal handleClose={close} />}
      </BigModal>
    </div>
  )
}

export default FAQ
